var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSortIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.385 10C1.32633 10 1.27133 9.978 1.22 9.934C1.176 9.89 1.154 9.835 1.154 9.769C1.154 9.73967 1.16133 9.70667 1.176 9.67L3.827 2.575C3.849 2.50167 3.88933 2.43933 3.948 2.388C4.014 2.32933 4.102 2.3 4.212 2.3H5.411C5.521 2.3 5.60533 2.32933 5.664 2.388C5.72267 2.43933 5.76667 2.50167 5.796 2.575L8.447 9.67C8.45433 9.70667 8.458 9.73967 8.458 9.769C8.458 9.835 8.436 9.89 8.392 9.934C8.348 9.978 8.29667 10 8.238 10H7.281C7.17833 10 7.10133 9.978 7.05 9.934C7.006 9.88267 6.97667 9.835 6.962 9.791L6.445 8.449H3.178L2.661 9.791C2.64633 9.835 2.61333 9.88267 2.562 9.934C2.518 9.978 2.44467 10 2.342 10H1.385ZM3.563 7.184H6.06L4.806 3.785L3.563 7.184Z",
    fill: "#020617"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.693 19C1.61967 19 1.55733 18.9743 1.506 18.923C1.45467 18.8717 1.429 18.8057 1.429 18.725V17.955C1.429 17.845 1.451 17.757 1.495 17.691C1.539 17.625 1.572 17.5773 1.594 17.548L5.422 12.598H1.803C1.72233 12.598 1.65633 12.5723 1.605 12.521C1.561 12.4697 1.539 12.4073 1.539 12.334V11.575C1.539 11.4943 1.561 11.4283 1.605 11.377C1.65633 11.3257 1.72233 11.3 1.803 11.3H7.061C7.14167 11.3 7.20767 11.3257 7.259 11.377C7.31033 11.4283 7.336 11.4943 7.336 11.575V12.334C7.336 12.422 7.32133 12.4953 7.292 12.554C7.26267 12.6127 7.22967 12.6677 7.193 12.719L3.442 17.691H7.182C7.26267 17.691 7.32867 17.7167 7.38 17.768C7.43133 17.8193 7.457 17.8853 7.457 17.966V18.736C7.457 18.8093 7.43133 18.8717 7.38 18.923C7.32867 18.9743 7.26267 19 7.182 19H1.693Z",
    fill: "#020617"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 13.0002L15 16.0002L18 13.0002",
    stroke: "#020617",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15 15.0002L15 5.00024",
    stroke: "#020617",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortIcon);
export default __webpack_public_path__ + "static/media/sort_icon.e6b1dff9507dda5694027d1a9b646f11.svg";
export { ForwardRef as ReactComponent };